module.exports = __webpack_public_path__ + "static/media/Strategic Mode of Governance Script_1642519480311.55119f43.docx";